import React from "react";
import styles from "../styles/CreateChatbot.module.css";
import { IoHomeOutline } from "react-icons/io5";

export default function YooKassaPayed({ language }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <h5 className={styles.price} style={{ color: "#000", fontSize: 25 }}>
        {language === "en"
          ? `You have successfully purchased messages! Your balance will soon be updated!`
          : `Вы успешно произвели оплату! Скоро токены поступят на ваш счет`}
      </h5>

      <button
        className={styles.submitBtn}
        style={{
          marginTop: 25,
          marginRight: 10,
          fontWeight: 100,
          fontSize: 19,
        }}
        onClick={async () => {
          var win: any;
          win = window.open("https://cyberchat-dashboard.vercel.app/", "_self");
        }}
      >
        <IoHomeOutline style={{ marginRight: 5 }} size={18} />
        {language === "en" ? "Home" : "Домой"}
      </button>
    </div>
  );
}
